module.exports = {"title":"Sorry!","description":"The browser you are using is not supported.<br />Please come back using Chome, Safari or Firefox.","close":"Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/BrowserNotSupportedModal/locales/en.json
// module id = 1320
// module chunks = 0